import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';


import { ServiceBase } from '@app/services/base.service';
import { TipoDeJulgamento } from "@app/models/tipo-de-julgamento.model";

@Injectable()
export class TipoDeJulgamentoService extends ServiceBase {
  constructor(
    private http: HttpClient,
  ) {
    super();
  }
  gravar(tipoDeJulgamento: TipoDeJulgamento): Observable<any> {
    return this.http.post<any>(this.URL_API + "configuracoes/tipoDeJulgamento", tipoDeJulgamento);
  }


  deletar(id: number): Observable<any> {
    return this.http.delete<any>(this.URL_API + `configuracoes/tipoDeJulgamento/${id}`);
  }

  obterPorId(id: number): Observable<any> {
    return this.http.get<any>(this.URL_API + `configuracoes/tipoDeJulgamento/${id}`);
  }

  obterLista(descricao: string, pagina: number): Observable<any> {
    descricao = encodeURIComponent(descricao);
    return this.http.get<any>(this.URL_API + `configuracoes/tipoDeJulgamento/lista/?descricao=${descricao}&pagina=${pagina}`, { headers: { meta: ['search'] }});
  }

}
